import Component from "@tunnel-components/@sharded/@widgets/dataPicker/component";
import * as React from "react";
import { connect } from "react-redux";
import * as moment from "moment";
import * as Lodash from "lodash";
import * as Utils from "@Cyclope-Utils/index";

/**
 * @class Container : Composant à état
 * @description : composant “complexe” recevant des props et possédant
 * un état interne pour générer son rendu.
 * @extends { React.PureComponent }
 * @implements
 * @method
 * @name onStartDateChange
 * @name
 * @name render
 * @infos "https://reactjs.org"
 */
class Container extends React.PureComponent<any, any> {
  /**
   * @constructor
   * @description :
   * Le Constructor est invoqué en premier.
   * Il reçoit en argument toutes les props initiales du composant
   * Le Constructor est aussi utilisé pour Binder les events Handler à l’instance.
   * @param { objet <any> } props
   */
  public constructor(props: any) {
    /**
     * @function
     * @description : Utilisé afin d'appeler ou d'accéder
     * à des fonctions définies sur l'objet parent.
     */
    super(props);
    /**
     * @namespace
     * @description : possède des informations sur le composant
     * @property { object }       state
     */
    this.state = {
      DaysActive: [],
      date: new Date(),
      isVisible: false,
      isSeconds: true,
      isSmall: false,
      selected: "",
      selectedHoursError: false,
      selectedMinutesError: false,
      selectedSecondsError: false,
    };
    /**
     * @description : Empêcher l'exécution des méthodes à chaque initialisation
     * des composants ; "seulement quand un event est exécuté"
     */
    this.onShowCalendar = this.onShowCalendar.bind(this);
    this.onHideCalendar = this.onHideCalendar.bind(this);
    this.onChangeYearMonth = this.onChangeYearMonth.bind(this);
    this.onSetDayOfMonth = this.onSetDayOfMonth.bind(this);
    this.onSetHoursMinutesSeconds = this.onSetHoursMinutesSeconds.bind(this);
    this.onResetDate = this.onResetDate.bind(this);
    this.onClearDate = this.onClearDate.bind(this);
    this.onChangeClearDate = this.onChangeClearDate.bind(this);
  }
  /**
   * changement des mois et années
   * @method onClearDate
   * @param { any }  event
   * @infos "https://reactdatepicker.com/"
   */
  public onClearDate = (event: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();
    {
      /** Empêcher la mutation du state */
    }

    const DaysActive: boolean[] = [];

    for (let i = 0; i < Math.ceil(this.state.DaysActive.length); i++) {
      DaysActive.push(false);
    }

    this.setState((state: any): any => ({
      isVisible: true,
      selectedHours: "",
      selectedMinutes: "",
      selectedSeconds: "",
      selected: "",
      DaysActive,
      selectedHoursError: false,
      selectedMinutesError: false,
      selectedSecondsError: false,
    }));
  };
  /**
   * changement des mois et années
   * @method onChangeClearDate
   * @param { any }  event
   * @infos "https://reactdatepicker.com/"
   */
  public onChangeClearDate = (event: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({
      isVisible: true,
      selectedHours: "",
      selectedMinutes: "",
      selectedSeconds: "",
      selected: "",
      selectedHoursError: false,
      selectedMinutesError: false,
      selectedSecondsError: false,
    }));
  };
  /**
   * fermeture ou ouverture du calandrier
   * @method onShowCalendar
   * @param { any }  event
   * @infos "https://reactdatepicker.com/"
   */
  public onShowCalendar = (event: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();
    {
      /** Empêcher la mutation du state */
    }

    this.setState((state: any): any => ({ isVisible: true }));
  };
  /**
   * fermeture ou ouverture du calandrier
   * @method onHideCalendar
   * @param { any }  event
   * @infos "https://reactdatepicker.com/"
   */
  public onHideCalendar = (event: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();
    {
      /** Empêcher la mutation du state */
    }

    this.setState((state: any): any => ({ isVisible: false }));
  };
  /**
   * initialisation de la date à la date d'aujourd'hui
   * @method onResetDate
   * @param { any }  event
   * @infos "https://reactdatepicker.com/"
   */
  public onResetDate = (event: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();
    {
      /** Empêcher la mutation du state */
    }

    this.setState((state: any): any => ({
      date: new Date(),
      selectedHours: moment(new Date()).hour(),
      selectedMinutes: moment(new Date()).minutes(),
      selectedSeconds: moment(new Date()).seconds(),
      selected: moment(new Date()),
      selectedHoursError: false,
      selectedMinutesError: false,
      selectedSecondsError: false,
    }));

    const DaysActive: boolean[] = [];

    for (let i = 0; i < Math.ceil(this.state.DaysActive.length); i++) {
      DaysActive.push(false);
    }

    DaysActive[new Date().getDate()] = true;
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({ DaysActive }));
  };
  /**
   * Cycle de vie d'un composant react
   * @method
   * @name
   * @description : il est appelée. Une fois le rendu fait,
   * C’est le moment idéal pour aller chercher
   * les références directes des éléments du DOM
   * @param { void }
   * @infos "https://reactjs.org"
   */
  public componentDidMount() {
    // recupération des
    /**
     * @description : la date
     * @const
     * @name daysInMonth
     * @type { Date }
     */
    const daysInMonth: number = moment(this.state.date).daysInMonth();
    /**
     * @description : la date
     * @const
     * @name firstDayDate
     * @type { Date }
     */
    const firstDayDate: any = moment(this.state.date).startOf("month");
    /**
     * @description : tableau contenant le label des Jour de la semaine
     * @const
     * @name Days
     * @type { any[]  }
     */
    const DaysActive: any[] = [];

    for (let i = firstDayDate.isoWeekday(); i > 1; i--) {
      DaysActive.push(false);
    }

    for (let i = 1; i <= daysInMonth; i++) {
      DaysActive.push(false);
    }
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({ DaysActive }));
  }

  /**
   * changement des mois et années
   * @method onChangeYearMonth
   * @param { any }  event
   * @infos "https://reactdatepicker.com/"
   */
  public onChangeYearMonth = (param: number, stack: string) => (
    event: any
  ): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();

    {
      /** Empêcher la mutation du state */
    }
    if (param === 1) {
      switch (stack) {
        case "month":
          {
            /** Empêcher la mutation du state */
          }
          this.setState((state: any): any => ({
            date: moment(this.state.date).add(1, "months"),
          }));
          break;
        case "year":
          {
            /** Empêcher la mutation du state */
          }
          this.setState((state: any): any => ({
            date: moment(this.state.date).add(1, "years"),
          }));
          break;
      }
    } else {
      switch (stack) {
        case "month":
          {
            /** Empêcher la mutation du state */
          }
          this.setState((state: any): any => ({
            date: moment(this.state.date).subtract(1, "months"),
          }));
          break;
        case "year":
          {
            /** Empêcher la mutation du state */
          }
          this.setState((state: any): any => ({
            date: moment(this.state.date).subtract(1, "years"),
          }));
          break;
      }
    }
  };
  /**
   * Changement des dates
   * @method onSetDayOfMonth
   * @param { any }  event
   * @infos "https://reactdatepicker.com/"
   */
  public onSetDayOfMonth = (param: any, length: number) => (event: any) => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({
      selectedHours: moment(new Date()).hour(),
      selectedMinutes: moment(new Date()).minutes(),
      selectedSeconds: moment(new Date()).seconds(),
      selected: moment(this.state.date)
        .set("date", Number(param))
        .set("hours", moment(new Date()).hour())
        .set("minutes", moment(new Date()).minutes())
        .set("seconds", moment(new Date()).seconds()),
      selectedHoursError: false,
      selectedMinutesError: false,
      selectedSecondsError: false,
    }));

    const DaysActive: boolean[] = [];
    for (let i = 0; i < Math.ceil(this.state.DaysActive.length); i++) {
      DaysActive.push(false);
    }
    DaysActive[param] = true;
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({ DaysActive }));
  };
  /**
   * Changement des heures
   * @method onSetHoursMinutesSeconds
   * @param { any }  event
   * @infos "https://reactdatepicker.com/"
   */
  public onSetHoursMinutesSeconds = (stack: string) => (event: any) => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.persist();
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any) => ({
      selectedHoursError: false,
      selectedMinutesError: false,
      selectedSecondsError: false,
    }));

    if (!Lodash.isUndefined(this.state.selected)) {
      switch (stack) {
        case "hours":
          if (
            Utils.validatorNumber(event.target.value) &&
            event.target.value >= 0 &&
            23 >= event.target.value
          ) {
            {
              /** Empêcher la mutation du state */
            }
            this.setState((state: any): any => ({
              selectedHours: event.target.value,
              selected: moment(this.state.selected).set(
                "hour",
                Number(event.target.value)
              ),
            }));
          } else {
            {
              /** Empêcher la mutation du state */
            }
            this.setState((state: any): any => ({
              selectedHours: event.target.value,
              selectedHoursError: true,
            }));
          }

          break;
        case "minutes":
          if (
            Utils.validatorNumber(event.target.value) &&
            event.target.value >= 0 &&
            59 >= event.target.value
          ) {
            {
              /** Empêcher la mutation du state */
            }
            this.setState((state: any): any => ({
              selectedMinutes: event.target.value,
              selected: moment(this.state.selected).set(
                "minutes",
                Number(event.target.value)
              ),
            }));
          } else {
            {
              /** Empêcher la mutation du state */
            }
            this.setState((state: any): any => ({
              selectedMinutes: event.target.value,
              selectedMinutesError: true,
            }));
          }
          break;
        case "seconds":
          if (
            Utils.validatorNumber(event.target.value) &&
            event.target.value >= 0 &&
            59 >= event.target.value
          ) {
            {
              /** Empêcher la mutation du state */
            }
            this.setState((state: any): any => ({
              selectedSeconds: event.target.value,
              selected: moment(this.state.selected).set(
                "seconds",
                Number(event.target.value)
              ),
            }));
          } else {
            {
              /** Empêcher la mutation du state */
            }
            this.setState((state: any): any => ({
              selectedSeconds: event.target.value,
              selectedSecondsError: true,
            }));
          }
          break;
      }
    }
  };
  /**
   * Cycle de vie d'un composant react
   * @method
   * @name componentDidUpdate
   * @description : La méthode  est appelée uniquement lorsque les props
   * ont changé et lorsqu'il ne s'agit pas d'un rendu initial
   * Le composant passe par une autre série d’étapes lorsque son parent refait son rendu
   * C’est l’endroit idéal pour vérifier si vos props vont changer par exemple
   * @param { any } prevProps
   * @param { any } prevState
   * @infos "https://reactjs.org"
   */
  public componentDidUpdate(prevProps: any, prevState: any) {
    {
      /** Comparaison des props */
    }

    if (prevState.selected !== this.state.selected) {
      this.props.onChangeSelected(this.state.selected);
    } else if (prevProps.selectedValue !== this.props.selectedValue) {
      if (Lodash.isEmpty(this.props.selectedValue)) {
        {
          /** Empêcher la mutation du state */
        }
        this.setState((state: any): any => ({ selected: "" }));

        const DaysActive: boolean[] = [];

        for (let i = 0; i < Math.ceil(this.state.DaysActive.length); i++) {
          DaysActive.push(false);
        }
        {
          /** Empêcher la mutation du state */
        }
        this.setState((state: any): any => ({ DaysActive }));
      }
    }
  }

  /**
   * Cycle de vie d'un composant react
   * @method
   * @name render
   * @description : il est appelée. Pour le rendu ,
   * Ici le DOM virtuel fusionne avec le DOM réel
   * @param {  }
   * @infos "https://reactjs.org"
   */
  public render() {
    return (
      <Component
        onChangeClearDate={this.onChangeClearDate}
        onClearDate={this.onClearDate}
        onResetDate={this.onResetDate}
        onSetHoursMinutesSeconds={this.onSetHoursMinutesSeconds}
        onSetDayOfMonth={this.onSetDayOfMonth}
        onChangeYearMonth={this.onChangeYearMonth}
        onHideCalendar={this.onHideCalendar}
        onShowCalendar={this.onShowCalendar}
        {...this.props}
        {...this.state}
      />
    );
  }
}

{
  /** exporter le HOC : connect */
}
export default connect(null, {})(Container);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@sharded/@widgets/dataPicker/container.tsx